import { PublicWorkerPool, WorkerPool } from "types/generated";
import { PUBLIC_WORKER_POOL_ID } from "views/Account/WorkerPool/constants";

import { WorkerPoolsTableRow } from "./types";

export const buildWorkerPoolsTableRows = (
  workerPools: WorkerPool[],
  publicWorkerPool: PublicWorkerPool | undefined
): WorkerPoolsTableRow[] => {
  const privateRows: WorkerPoolsTableRow[] = workerPools.map((workerPool) => ({
    id: workerPool.id,
    kind: "private",
    workerPool,
  }));

  if (!publicWorkerPool) {
    return privateRows;
  }

  return [{ id: PUBLIC_WORKER_POOL_ID, kind: "public", publicWorkerPool }, ...privateRows];
};
